import { Button, FormGroup } from "reactstrap";
import { useEffect, useState } from "react";
const YesOrNo = ({ input, label, options, disabled,defaultValue }: any) => {
  const [selected, setSelected] = useState("");
  const onChangeValues = (event: any) => {
    event.preventDefault();
    setSelected(event.target.value);
    return input.onChange(event.target.value);
  };
  useEffect(() => {
    setSelected(input.value || defaultValue);
  }, [input.value, defaultValue]);

  return (
    <FormGroup className="yesOrNO mt-0">
      <label>{label}</label>
      <div className="d-flex">
        {options?.map((element: any, index: number) => (
          <Button
            disabled={disabled}
            key={input.name + index}
            type="button"
            name={input.name}
            className={`${element.value === selected ? "optSelected" : "optNotSelected"}`}
            value={element.value}
            onClick={onChangeValues
            }
          >
            {element.text}
          </Button>
        ))}
      </div>
    </FormGroup>
  );
};

export default YesOrNo;
